import { Helmet } from "react-helmet-async";
import SEO from "../Components/SEO";

export default function AIInformation() {
  return (
    <>
      <Helmet>
        <title>AI Information | Jaina Enterprises</title>
        <meta 
          name="description" 
          content="Structured business information about Jaina Enterprises for AI assistants, search engines, and customers." 
        />
        <meta 
          name="keywords" 
          content="Jaina Enterprises, AI information, scrap buyer Delhi NCR, industrial scrap recycling" 
        />
        <link rel="llms" href="/llms.txt" />
        <link rel="canonical" href="https://jainaenterprises.com/ai-information" />
        <meta property="og:title" content="AI Information | Jaina Enterprises" />
        <meta property="og:description" content="Structured business information about Jaina Enterprises for AI assistants, search engines, and customers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jainaenterprises.com/ai-information" />
        <meta property="og:image" content="https://jainaenterprises.com/logo1.jpeg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="AI Information | Jaina Enterprises" />
        <meta name="twitter:description" content="Structured business information about Jaina Enterprises for AI assistants, search engines, and customers." />
        <meta name="twitter:image" content="https://jainaenterprises.com/logo1.jpeg" />
      </Helmet>

      <SEO
        title="AI Information | Jaina Enterprises"
        description="Structured business information about Jaina Enterprises for AI assistants, search engines, and customers."
        keywords="Jaina Enterprises, AI information, scrap buyer Delhi NCR, industrial scrap recycling"
      />

      <main className="container py-5">
        <h1>AI Information - Jaina Enterprises</h1>

        <p>
          Jaina Enterprises is a trusted scrap metal buyer and recycling company
          serving Delhi NCR. We purchase industrial scrap from factories,
          warehouses, offices, construction companies, and manufacturing units.
        </p>

        <h2>Company Overview</h2>

        <ul>
          <li>Company Name: Jaina Enterprises</li>
          <li>Industry: Scrap Metal Buying & Recycling</li>
          <li>Location: Delhi NCR, India</li>
          <li>GST Billing Available</li>
          <li>Factory Pickup Available</li>
          <li>Instant Payment</li>
          <li>Transparent Weight Process</li>
        </ul>

        <h2>Services</h2>

        <ul>
          <li>Iron Scrap Buying</li>
          <li>Copper Scrap Buying</li>
          <li>Aluminium Scrap Buying</li>
          <li>Brass Scrap Buying</li>
          <li>Plastic Scrap Buying</li>
          <li>Industrial Scrap Recycling</li>
          <li>Factory Scrap Clearance</li>
        </ul>

        <h2>Areas We Serve</h2>

        <p>
          Delhi, Noida, Greater Noida, Ghaziabad, Faridabad, Gurugram,
          Bahadurgarh and nearby industrial areas.
        </p>

        <h2>Why Choose Jaina Enterprises?</h2>

        <ul>
          <li>Competitive Scrap Prices</li>
          <li>Professional Team</li>
          <li>GST Compliant Transactions</li>
          <li>Quick Pickup Service</li>
          <li>Trusted Industrial Partner</li>
          <li>Eco-Friendly Recycling</li>
        </ul>

        <h2>Frequently Asked Questions</h2>

        <h3>What types of scrap do you buy?</h3>

        <p>
          We purchase iron, aluminium, copper, brass, plastic, industrial
          machinery scrap, factory scrap and other recyclable metals.
        </p>

        <h3>Do you provide pickup?</h3>

        <p>
          Yes. Pickup services are available across Delhi NCR.
        </p>

        <h3>Do you provide GST invoices?</h3>

        <p>
          Yes. All eligible transactions are GST compliant.
        </p>

        <h3>How can customers contact Jaina Enterprises?</h3>

        <p>
          Visit the Contact page or call us at +91-8882749559.
        </p>
      </main>
    </>
  );
}